import "slick-carousel/slick/slick.css";
import "tailwindcss/dist/base.css";
import "./src/styles/global.css";
